<template>
    <div v-if="shouldShowHeader">
      <appHeader></appHeader>
    </div>
    <div class="content">
      <router-view/>
    </div>
    <appFooter v-if="shouldShowFooter"></appFooter>
</template>

<script>
import Header from "../src/components/Header.vue"
import Footer from "../src/components/Footer.vue"

export default {
  components: {
    appHeader: Header,
    appFooter: Footer,
  },
  computed: {
    shouldShowHeader() {
      const requiresHeader = this.$route.meta.requiresHeader;
      return typeof requiresHeader === 'undefined' || requiresHeader;
    },
    shouldShowFooter() {
      const requiresFooter = this.$route.meta.requiresFooter;
      return typeof requiresFooter === 'undefined' || requiresFooter;
    },
  },
  created() {
    document.title = "Minex";
  }
}
</script>

<style lang="scss" src="@/assets/css/App.scss"></style>